export default "__VITE_ASSET__Ck$Z8OeL__"